import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../../../../hooks/hooks";
import { selectOrdersListItems } from "../../../../../../../../redux/orders/selector";
import { selectListItems } from "../../../../../../../../redux/library/selector";
import { orders } from "../../../../../../../../redux/orders/action";
import PageLoader from "../../../../../../../../components/PageLoader";
import MobileViewTable from "../../../../../../../../common/components/mobile-view-table.component";

const CustomerOrdersMobile = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [index, setIndex] = useState(1)
  const [hasMore, setHasMore] = useState();
  const [rawData, setRawData] = useState<any>([])
  const [orderData, setOrderData] = useState<any>([])
  const itemsData = useSelector(selectOrdersListItems)
  const libraryData = useSelector(selectListItems)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});


  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Message.InvoiceNumber', headerName: 'Invoice Number', sortable: true, filter: true, isGeneratedPrintOrders: true },
      { field: 'Message.ShipmentPId', headerName: 'Order Id', search: true },
      { field: 'Message.TransporterName', headerName: 'Transporter Name' },
      { field: 'Message.AgentName', headerName: 'Agent Name' },
      { field: 'Message.TrackingNumber', headerName: 'Tracking Number', sortable: false, filter: true },
      {
        field: 'Message.LogisticsOrderStatusId',
        headerName: 'Order Status',
        cellRenderer: 'libraryRendererComponent',
        cellRendererParams: { library: libraryData?.result?.LogisticsOrderStatus },
        sortable: true,
        filter: false, isRowColorDecider: true
      },
      { field: 'Message.CreatedOnUtc', headerName: 'Order Date', isDateValueFormat: true },
      { field: 'Message.DeliveryDateUtc', headerName: 'Schedule Date & Time', isDateValueFormat: true },
    ]);
  }

  const fetchOrders = async (_page: any, size: any) => {
    await dispatch(orders.resetAction({ actionType: 'list' }))
    await dispatch(orders.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/list`, entity: 'order', jsonData: {
        "PageNumber": _page,
        "PageSize": size,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }

  const handleSearch = async (data: any) => {

    const searchCriteria = [{
      FieldName: "ShipmentPId",
      FieldText: "ShipmentPId",
      FieldType: 'text',
      FilterOperatorId: 6,
      FieldValue: data?.value
    }]
    await setOrderData([])
    await dispatch(orders.resetAction({ actionType: 'list' }))
    await dispatch(orders.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/shipments/list`, entity: 'order', jsonData: {
        "PageNumber": index,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",
        "Searches": searchCriteria,
      }
    }));
  }

  useEffect(() => {

    if (index > 1) {
      fetchOrders(index, 10)
      createColumnDefs()
    }
  }, [index])

  useEffect(() => {
    createColumnDefs()
    fetchOrders(index, 10)
  }, [])

  const handleEdit = (data: any) => {
    navigate(`${data?.Message?.Id}`)
  }

  const fetchMoreData = () => {
    const prevIndex = index
    setIndex(prevIndex + 1);
  };

  const additionButtons: any = [

    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload cards</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      callback: () => handlereload(),
    }
  ];

  const handlereload = async () => {
    await setOrderData([])
    await fetchOrders(index, 10)
  }

  useEffect(() => {
    if (itemsData?.result?.items) {
      setRawData(itemsData?.result?.items)
      setHasMore(itemsData?.result?.pagination?.HasNextPage)
    }
  }, [itemsData]);

  useEffect(() => {
    let formatedData = []
    rawData.map((data: any) => {
      formatedData.push({
        context: data?.context,
        Message: {
          Id: data?.Message?.Id,
          InvoiceNumber: data?.Message?.InvoiceNumber,
          ShipmentPId: data?.Message?.ShipmentPId,
          TransporterName: data?.Message?.TransporterName,
          AgentName: data?.Message?.AgentName,
          TrackingNumber: data?.Message?.TrackingNumber,
          LogisticsOrderStatusId: data?.Message?.LogisticsOrderStatusId,
          CreatedOnUtc: data?.Message?.CreatedOnUtc,
          DeliveryDateUtc: data?.Message?.DeliveryDateUtc,
        }
      })
    })
    if (index > 1) {
      setOrderData([...orderData, ...formatedData])
    } else {
      setOrderData(formatedData)
    }

  }, [rawData])


  const handleGeneratePrintOrdersInvoice = async (data: any) => {
    navigate(`/customer/order/invoice/${data?.Message?.InvoiceNumber}`)
  }

  return (
    <>
      {itemsData?.isLoading && index == 1 ? <PageLoader />
        :

        <MobileViewTable onSearch={handleSearch}
          dataLength={orderData.length}
          fetchMoreData={fetchMoreData}
          hasMore={hasMore}
          additionButtons={additionButtons}
          columnData={columnDefs}
          rowData={orderData}
          onEdit={handleEdit}
          onGeneratePrintOrderInvoice={handleGeneratePrintOrdersInvoice}
          headingName="Orders" />


      }
    </>



  );

};

export default CustomerOrdersMobile;


